import {Helmet} from "react-helmet-async";
import moment from 'moment';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Container,
    Grid,
    IconButton,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Iconify from "../components/iconify";
import {config} from "../constant";
import ChatMsg from "../components/chat";
import UserContext from "../UserContext";
import DialogIdentification from "../sections/@dashboard/dialog-identification/DialogIdentification";
import DialogEditNomination from "../sections/@dashboard/nomination/DialogEditNomination";
import ContextMenu from "../components/context-menu/ContextMenu";
import DialogEditComment from "../sections/@dashboard/nomination/DialogEditComment";
import DialogEditCategory from "../sections/@dashboard/nomination/DialogEditCategory";
import DialogEditMail from "../sections/@dashboard/nomination/DialogEditMail";

export default function NominationPage() {
    const {user, setUser} = useContext(UserContext);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
    const [mailDialogOpen, setMailDialogOpen] = useState(false);
    const [commentDialogOpen, setCommentDialogOpen] = useState(false);
    const [identificationDialogOpen, setIdentificationDialogOpen] = useState(false);
    const [nomination, setNomination] = useState(null);
    const [category, setCategory] = useState(null);
    const [comment, setComment] = useState(null);
    const [categoriesAndNominations, setCategoriesAndNominations] = useState([]);
    const [nominationsAndComments, setNominationsAndComments] = useState([]);
    const [users, setUsers] = useState([]);

    const [nominationContextMenu, setNominationContextMenu] = useState(null);
    const [categoryContextMenu, setCategoryContextMenu] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        updateList();

        fetch(`${config.BASE_URL}/people`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            }).then(data => {
                setUsers(data);
            }).catch(error => {
                const message = 'Erreur dans la récupération des utilisateurs';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });

        // getComments();
    }, []);

    // useEffect(() => {
    //     if (identificationBeforeComment) {
    //         // Changement de user : édition d'un commentaire
    //         setCommentDialogOpen(true);
    //         setIdentificationBeforeComment(false);
    //     }
    // }, [user]);

    const updateList = () => {
        fetch(`${config.BASE_URL}/nominations/by-categories`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            }).then(data => {
                setCategoriesAndNominations(data);
            }).catch(error => {
                const message = 'Erreur dans la récupération des nominations';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });

        getComments();
    };

    const handleCloseNominationDialog = (refresh) => {
        setDialogOpen(false);
        if (refresh) {
            updateList();
        }
    };

    const deleteNomination = () => {
        const requestOptions = {
            method: 'DELETE'
        };
        fetch(`${config.BASE_URL}/nominations/${nomination.id}`, requestOptions)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                updateList();
            }).catch((error) => {
                const message = 'Erreur dans la suppression d\'une nomination';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    // Catégorie
    const handleCloseCategoryDialog = (refresh) => {
        setCategoryDialogOpen(false);
        if (refresh) {
            updateList();
        }
    };

    const deleteCategory = () => {
        const requestOptions = {
            method: 'DELETE'
        };
        fetch(`${config.BASE_URL}/categories/${category.id}`, requestOptions)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                setCategory(null);
                updateList();
            }).catch((error) => {
                const message = 'Erreur dans la suppression d\'une catégorie';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    // Commentaire
    const handleEditComment = (id, comments) => {
        setComment(comments.find(current => current.id === id));
        setCommentDialogOpen(true);
    };

    const editComment = () => {
        if (!user) {
            setIdentificationDialogOpen(true);
        } else {
            setCommentDialogOpen(true);
        }
    };

    const getComments = () => {
        fetch(`${config.BASE_URL}/comments/by-nominations`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            }).then(data => {
                data.forEach(nominationsAndComments => {
                    nominationsAndComments.nomination.nominees = [];
                });
                setNominationsAndComments(data);
            }).catch(error => {
                const message = 'Erreur dans la récupération des commentaires';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const groupByAuthor = (comments) => {
        const authorsAndComments = [];
        let currentAuthorId = null;
        let currentAuthorAndComments = null;
        comments.forEach(comment => {
            if (currentAuthorId === null || comment.author.id !== currentAuthorId) {
                currentAuthorId = comment.author.id;
                currentAuthorAndComments = {
                    author: comment.author,
                    comments: [comment]
                };
                authorsAndComments.push(currentAuthorAndComments);
            } else {
                currentAuthorAndComments.comments.push(comment);
            }
        });
        return authorsAndComments;
    };

    const deleteComments = (comments) => {
        const requestOptions = {
            method: 'DELETE'
        };
        comments.forEach(comment => {
            fetch(`${config.BASE_URL}/comments/${comment.id}`, requestOptions)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`${response.status} ${response.statusText}`)
                    }
                    getComments();
                }).catch((error) => {
                    const message = 'Erreur dans la suppression de commentaires';
                    console.error(message, error);
                    navigate("/error", {state: {message: message}});
                });
        });
    };

    // const useStyles = makeStyles({
    //     root: {
    //         padding: '10px',
    //         '&:last-child': {
    //             paddingBottom: 10,
    //         }
    //     },
    //     headerTitle: {
    //         fontSize: '0.9rem',
    //         fontWeight: 'initial'
    //     }
    // });
    //
    // const materialUIClasses = useStyles();

    return (
        <>
            <Helmet>
                <title>Nominations | Lose Awards</title>
            </Helmet>

            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Nominations
                    </Typography>
                    <Stack direction="row" spacing={2}>
                        {/*<Button*/}
                        {/*    variant="contained"*/}
                        {/*    startIcon={<Iconify icon="eva:plus-fill" />}*/}
                        {/*    onClick={() => {*/}
                        {/*        setNomination(null);*/}
                        {/*        setCategory(null);*/}
                        {/*        setDialogOpen(true);*/}
                        {/*    }}*/}
                        {/*    style={{textTransform: 'none'}}*/}
                        {/*>*/}
                        {/*    Ajouter une nomination*/}
                        {/*</Button>*/}
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={() => {
                                setCategory(null);
                                setCategoryDialogOpen(true);
                            }}
                            style={{textTransform: 'none'}}
                        >
                            Ajouter une catégorie
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:email-fill" />}
                            onClick={() => setMailDialogOpen(true)}
                            style={{textTransform: 'none'}}
                        >
                            Mail
                        </Button>
                    </Stack>
                </Stack>

                <Grid container spacing={1}>
                    <Grid item xs={9}>
                        {categoriesAndNominations && categoriesAndNominations.map((categoryAndNominations) => (
                            <Accordion key={categoryAndNominations.category.id}>
                            {/*<Accordion key={categoryAndNominations.category.id} disableGutters elevation={0}>*/}
                                {/*<AccordionSummary expandIcon={<ExpandMoreIcon/>} aria-controls="panel1a-content" id="panel1a-header" sx={{ flexGrow: 1 }}>*/}
                                {/*    <Typography>{categoryAndNominations.category.name}</Typography>*/}
                                {/*</AccordionSummary>*/}
                                <Box sx={{display: "flex"}}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>} aria-controls="panel1a-content" id="panel1a-header" sx={{ flexGrow: 1, flexDirection: "row-reverse" }}>
                                        <Typography sx={{marginLeft: 2}}>{categoryAndNominations.category.name}</Typography>
                                    </AccordionSummary>
                                    <Box sx={{marginRight: 1, paddingTop: 0.2}}>
                                        <IconButton size="large" color="inherit" onClick={event => {
                                            setCategory(categoryAndNominations.category);
                                            setCategoryContextMenu(event.currentTarget);
                                        }}>
                                            <Iconify icon={'eva:more-vertical-fill'} />
                                        </IconButton>
                                    </Box>
                                </Box>
                                {/*<Box sx={{ display: "flex" }}>*/}
                                {/*  <AccordionSummary expandIcon={<ExpandMoreIcon/>} aria-controls="panel1a-content" id="panel1a-header" sx={{*/}
                                {/*      flexGrow: 1,*/}
                                {/*      "&.Mui-expanded": {*/}
                                {/*          minHeight: 0*/}
                                {/*      },*/}
                                {/*      "& .MuiAccordionSummary-content.Mui-expanded": {*/}
                                {/*          margin: "12px 0"*/}
                                {/*      }*/}
                                {/*  }}>*/}
                                {/*    <Typography>{categoryAndNominations.category.name}</Typography>*/}
                                {/*  </AccordionSummary>*/}
                                {/*  <Box sx={{ marginRight: 1 }}>*/}
                                {/*      <IconButton size="large" color="inherit" onClick={(event) => handleOpenMenu(event, nomination)}>*/}
                                {/*          <Iconify icon={'eva:more-vertical-fill'} />*/}
                                {/*      </IconButton>*/}
                                {/*  </Box>*/}
                                {/*</Box>*/}

                                <AccordionDetails>
                                    {/*Nominations d'une catégorie*/}
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell /*sx={{paddingY: '2px'}}*/>Nominés</TableCell>
                                                    <TableCell /*sx={{paddingY: '2px'}}*/>Raison</TableCell>
                                                    <TableCell sx={{paddingY: 0, paddingRight: 1}} align="right">
                                                        <IconButton
                                                            size="large"
                                                            color="inherit"
                                                            onClick={() => {
                                                                setCategory(categoryAndNominations.category);
                                                                setNomination(null);
                                                                setDialogOpen(true);
                                                            }}
                                                        >
                                                            <Iconify icon={'eva:plus-fill'} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {categoryAndNominations.nominations.length > 0 ? (
                                                    <>
                                                        {categoryAndNominations.nominations.map(nomination => (
                                                            <TableRow hover key={nomination.id}>
                                                                <TableCell sx={{paddingY: '2x"'}}>
                                                                    {nomination.nominees.length > 0 && nomination.nominees.map(nominee => <span key={nominee.id}>{nominee.firstName}</span>).reduce((previousValue, currentValue) => [previousValue, ', ', currentValue])}
                                                                </TableCell>
                                                                <TableCell sx={{paddingY: '2px'}}>
                                                                    {nomination.reason}
                                                                </TableCell>
                                                                <TableCell align="right" sx={{paddingY: 0}}>
                                                                    <IconButton size="large" color="inherit" onClick={event => {
                                                                        setNomination(nomination);
                                                                        setNominationContextMenu(event.currentTarget);
                                                                    }}>
                                                                        <Iconify icon={'eva:more-vertical-fill'} />
                                                                    </IconButton>
                                                                    {/*<Box sx={{ display: "flex" }}>*/}
                                                                    {/*    <IconButton style={{ padding: 0 }} onClick={() => editNomination(nomination)}><Edit /></IconButton>*/}
                                                                    {/*    <IconButton style={{ padding: 0 }} onClick={() => deleteNomination(nomination.id)}><Delete /></IconButton>*/}
                                                                    {/*</Box>*/}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                     </>
                                                ) : (
                                                    <TableRow>
                                                        <TableCell align="center" colSpan={3}>
                                                            <Paper sx={{textAlign: 'center'}}>
                                                                Aucune nomination
                                                            </Paper>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {/*<Box sx={{display: 'flex', justifyContent: 'flex-start', p: 2}}>*/}
                                    {/*  <Button color="primary" variant="contained" onClick={() => setDialogOpen(true)}>Ajouter une nomination</Button>*/}
                                    {/*</Box>*/}
                                    {/*<Stack direction="row" spacing={2} sx={{pt: 2}}>*/}
                                    {/*    <Button variant="outlined" startIcon={<AddCircleOutlineIcon />} onClick={() => addNomination(categoryAndNominations.category)}>Ajouter une nomination</Button>*/}
                                    {/*    <Button variant="outlined" startIcon={<EditIcon />} onClick={() => editCategory(categoryAndNominations.category)}>Renommer la catégorie</Button>*/}
                                    {/*    <Button variant="outlined" startIcon={<DeleteIcon />} color="error" onClick={() => deleteCategory(categoryAndNominations.category.id)}>Supprimer la catégorie</Button>*/}
                                    {/*</Stack>*/}
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Grid>

                    {/* Commentaires */}
                    <Grid item xs={3}>
                        {nominationsAndComments && nominationsAndComments.map((nominationAndComment) => (
                            <Card key={nominationAndComment.nomination.id} sx={{marginBottom: 1, boxShadow: 3}}>
                                <CardHeader
                                    // className={materialUIClasses.root}
                                    action={
                                      <IconButton
                                          onClick={() => {
                                              setNomination(nominationAndComment.nomination);
                                              setComment(null);
                                              editComment();
                                          }}
                                      >
                                          <Iconify icon={'eva:message-square-outline'} />
                                      </IconButton>
                                    }
                                    // classes={{
                                    //     title: materialUIClasses.headerTitle
                                    // }}
                                    sx={{
                                        padding: '6px 10px 6px 10px',
                                        bgcolor: 'action.selected',
                                        '& .MuiCardHeader-title': {
                                            fontSize: '0.8rem',
                                            fontWeight: 'initial'
                                        }
                                    }}
                                    title={nominationAndComment.nomination.reason}
                                />
                                <CardContent
                                    sx={{
                                        padding: '9px',
                                        '&:last-child': {
                                            paddingBottom: '3px'
                                        }
                                    }}
                                    // className={materialUIClasses.root}
                                >
                                    {groupByAuthor(nominationAndComment.comments).map(authorAndComments => {
                                        const avatarUrl = authorAndComments.author.avatar ? `data:${authorAndComments.author.avatar.contentType};base64,${authorAndComments.author.avatar.data}` : '/assets/images/avatars/avatar_1.jpg';
                                        const formattedDate = moment(authorAndComments.comments[0].date).format('DD/MM/yyyy');
                                        const isAuthor = user && user.id === authorAndComments.author.id;
                                        return (
                                            <ChatMsg
                                                key={authorAndComments.comments[0].id}
                                                avatar={avatarUrl}
                                                messages={authorAndComments.comments.map(({id, content}) => ({id, content}))}
                                                side={isAuthor ? 'right' : 'left'}
                                                date={formattedDate}
                                                onEdit={isAuthor ? (id) => handleEditComment(id, authorAndComments.comments) : null}
                                                onDelete={isAuthor ? () => deleteComments(authorAndComments.comments) : null}
                                            />
                                        );
                                    })}
                                </CardContent>
                            </Card>
                        ))}
                    </Grid>
                </Grid>
            </Container>

            {dialogOpen && (
                <DialogEditNomination
                    open={dialogOpen}
                    onClose={handleCloseNominationDialog}
                    nomination={nomination}
                    categoryId={category ? category.id : null}
                    users={users}
                    categories={categoriesAndNominations.map(categoryAndNomination => categoryAndNomination.category)}
                >
                </DialogEditNomination>
            )}

            {categoryDialogOpen && (
                <DialogEditCategory
                    open={categoryDialogOpen}
                    onClose={handleCloseCategoryDialog}
                    category={category}
                >
                </DialogEditCategory>
            )}

            {mailDialogOpen && (
                <DialogEditMail
                    open={mailDialogOpen}
                    onClose={() => setMailDialogOpen(false)}
                >
                </DialogEditMail>
            )}

            {commentDialogOpen && (
                <DialogEditComment
                    open={commentDialogOpen}
                    onClose={refresh => {
                        setCommentDialogOpen(false);
                        if (refresh) {
                            getComments();
                        }
                    }}
                    comment={comment}
                    nomination={nomination}
                >
                </DialogEditComment>
            )}

            {identificationDialogOpen && (
                <DialogIdentification
                    open={identificationDialogOpen}
                    onClose={(reason, identified) => {
                        setIdentificationDialogOpen(false);
                        if (identified) {
                            setCommentDialogOpen(true);
                        }
                    }}
                >
                </DialogIdentification>
            )}

            <ContextMenu
                target={categoryContextMenu}
                setTarget={setCategoryContextMenu}
                handleEdit={() => setCategoryDialogOpen(true)}
                handleDelete={deleteCategory}
            >
            </ContextMenu>

            <ContextMenu
                target={nominationContextMenu}
                setTarget={setNominationContextMenu}
                handleEdit={() => setDialogOpen(true)}
                handleDelete={deleteNomination}
                handleComment={editComment}
            >
            </ContextMenu>
        </>
    );
}